import { defineStore } from "pinia";
import { version } from "../../package";
import { getApiLiveness } from "@/api/systemApi";

export const useSystemStore = defineStore("systemStore", {
  state: () => ({
    appVersion: version,
    apiLivenes: null,
  }),

  getters: {
    getAppVersion(store) {
      return store.appVersion;
    },

    getApiVersion(store) {
      if (!store.apiLivenes) return null;
      return store.apiLivenes.buildInfo;
    },
  },

  actions: {
    async loadApiLivenes() {
      try {
        this.apiLivenes = await getApiLiveness();
      } catch (error) {
        // showError(error);
      }
    },
  },
});
